import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { preloadFonts } from './utils/fontPreloader';

// ============================================
// 🚨 ВАЖНО: MOCK BACKEND - ТОЛЬКО ДЛЯ ТЕСТИРОВАНИЯ!
// ============================================
// Mock Backend для тестирования UI без реального сервера
// 
// ⚠️ ПЕРЕД ДЕПЛОЕМ НА DEV/PROD ОБЯЗАТЕЛЬНО ЗАКОММЕНТИРУЙТЕ ЭТУ СТРОКУ! ⚠️
// См. подробную инструкцию в файле: MOCK_BACKEND_README.md
//
// import './mockBackend'; // ← ЗАКОММЕНТИРУЙТЕ ПЕРЕД ДЕПЛОЕМ!
// ============================================

// Раняя предзагрузка шрифтов, чтобы уменьшить лаги при первом рендере
preloadFonts();

// Инициализация Telegram WebApp
if (window.Telegram?.WebApp) {
    const tg = window.Telegram.WebApp;

    // Уведомляем Telegram о готовности приложения
    tg.ready();

    // Проверяем платформу
    // 1. Берём из URL (?platform=android|ios|web и т.п.)
    // 2. Если нет в URL — берём из Telegram WebApp
    const urlParams = new URLSearchParams(window.location.search);
    const platformFromUrl = urlParams.get('test_platform');

    const platform = platformFromUrl || tg.platform;
    const isMobile = platform === 'android' || platform === 'ios';

    // Добавляем классы платформы на html для адаптации стилей (мобильная / десктоп)
    const rootElement = document.documentElement;
    rootElement.classList.add(`tg-platform-${platform}`);
    rootElement.classList.add(isMobile ? 'tg-platform-mobile' : 'tg-platform-desktop');

    if (isMobile) {
        // Расширяем приложение на максимальную высоту только на мобильных
        tg.expand();

        // Включаем полноэкранный режим, если доступно (Telegram 8.0+)
        if (typeof tg.requestFullscreen === 'function') {
            try {
                tg.requestFullscreen();
            } catch (error) {
                console.warn('Не удалось включить полноэкранный режим:', error);
            }
        }
    }

    // Запрещаем закрытие свайпом вниз (отключаем вертикальные свайпы)
    if (tg.initDataUnsafe?.user) {
        if (typeof tg.disableVerticalSwipes === 'function') {
            tg.disableVerticalSwipes();
        } else if (typeof tg.disableClosingConfirmation === 'function') {
            // Fallback для старых версий SDK
            tg.disableClosingConfirmation();
        }
    }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />
);
